export default __webpack_public_path__ + "static/media/sun.85f23d47.jpg";